export const defaultLabel = {
    labelId: 0,
    nameCN: "待定",
    name: "unlabeled",
    color: "#ffffff"
  };
  


// WEBPACK FOOTER //
// ./src/redux/defaultValues.js